import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import { onMounted, ref, computed } from "vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";


export default /*@__PURE__*/_defineComponent({
  __name: '_ticket-image-modal',
  props: {
    trigger: {},
    image: {},
    alt: {},
    rotated: {}
  },
  setup(__props: any) {

const props = __props;

const isOpened = ref<boolean>(false);

const isRotated = computed(() => !!props.rotated);

onMounted(() => {
    // Bind open triggers
    const trigger = document.querySelector(`.js-tim-trigger#${props.trigger}`);
    if (!trigger) return;

    trigger.addEventListener("click", (e) => {
        e.preventDefault();

        isOpened.value = true;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsModalDialog, {
    modelValue: isOpened.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpened).value = $event))
  }, {
    content: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.image,
        alt: _ctx.alt,
        class: _normalizeClass({ rotated: isRotated.value })
      }, null, 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})